import { useCurrencies } from "@/modules/reports/contexts/currency-context";
import { useQuery } from "@tanstack/react-query";
import { getItemsFromCollection } from "directus/src/operations";

const calculateTotalStats = (billables, convertToINR) => {
  const totalAmount = billables.reduce((sum, billable) => {
    const convertedAmount = convertToINR(
      billable.amount || 0,
      billable.currency
    );
    return sum + convertedAmount;
  }, 0);

  return {
    totalAmount,
    count: billables.length,
  };
};

export const useTotalBillableStats = (dateRange) => {
  const { convertToINR, isLoading: currenciesLoading } = useCurrencies();

  return useQuery({
    queryKey: ["billable-total-stats", dateRange],
    queryFn: async () => {
      if (!dateRange) {
        return { totalAmount: 0, count: 0 };
      }

      const dateFilter = {
        _lte: dateRange.to,
        _gte: dateRange.from,
      };

      const billablesQuery = {
        fields: [
          "id",
          "amount",
          "adjusted_amount",
          "currency",
          "status",
          "billing_date",
        ],
        filter: {
          job: { project: { _nnull: true } },
          billing_date: dateFilter,
          status: { _nin: ["cancelled", "archived"] },
        },
        limit: -1,
      };

      const billablesResponse = await getItemsFromCollection(
        "billables",
        billablesQuery
      );

      return calculateTotalStats(billablesResponse, convertToINR);
    },
    enabled: !currenciesLoading && !!dateRange,
  });
};
